/* PASSWORD RESET COMPONENT ***************************************************/

import React, { ReactDOM, PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* 3rd Party Tools */
import MobileDetect from 'mobile-detect'

/* Widgets */
import TextInput from 'widget/text-input'
import InfoText from 'widget/info-text'

/* Assets */
import logo from 'assets/logo_transparent.png'

/* Styles */
import './password-reset.css'

/* Actions */
import {
   resetPassword
} from 'react-redux/actions/user'

/* utils */
import { getParam, getBaseUrl } from 'util/url'

/* Login Component like used on the landing page */
class PasswordReset extends Component {

  constructor(props) {
    super(props)
    this.state = {
      validPassword: false,
      passwordNotification: null,
      newPassword: "",
      repeatedPassword: ""
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.newPassword !== this.state.newPassword
      || prevState.repeatedPassword !== this.state.repeatedPassword
    )
    this.validatePassword()
  }

  componentDidMount() {
    this.passwordInput.focus() // set cursor to emailInput field
  }

  /* show background video on non mobile devices */
  renderVideo() {
    var isMobile = new MobileDetect(window.navigator.userAgent).mobile()
    if (!isMobile) return <video src="media/arch.mp4" autoPlay loop muted/>
    return null
  }

  /* render error if necessary */
  renderError() {
    const { t, error } = this.props
    if (error) return (
      <div className="login-error">{ t('notification:message.'+error) }</div>
    )
    return null
  }

  isChrome() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }

  renderChromeMessage() {
    const { t } = this.props
    if(!this.isChrome()) return (
      <div className="chrome-message">
        { t('user:login.chromeMessage') }
        <a href="https://www.google.com/chrome/" target="blank">
          Download Google Chrome
        </a>
      </div>
    )
    return null
  }

  validatePassword() {
    const { currentPassword, newPassword, repeatedPassword } = this.state
    if (!newPassword  && !repeatedPassword) {
      this.setState({ validPassword: false, passwordNotification: null})
    } else if (!newPassword) {
      this.setState({
        validPassword: false,
        passwordNotification: "user:profile.noNewPassword"
      })
    } else if (newPassword.length < 6) {
      this.setState({
        validPassword: false,
        passwordNotification: "user:profile.newPasswordToShort"
      })
    } else if (newPassword !== repeatedPassword){
      this.setState({
        validPassword: false,
        passwordNotification: "user:profile.passwordsDontMatch"
      })
    } else {
      this.setState({ validPassword: true, passwordNotification: null})
    }
  }

  onKeyDown(e) {
    const { validPassword, newPassword } = this.state
    const { resetPassword } = this.props
    if (!validPassword) return // ignore all events while not in edit mode
    switch (e.keyCode) {
      case 13: // enter
        e.preventDefault()
        e.stopPropagation()
        resetPassword(getParam('reset_token'), newPassword)
        window.location.href = getBaseUrl()
        break
    }
  }

  onNewPasswordChange(e) {
    this.setState({newPassword:e.target.value})
  }

  onRepeatPasswordChange(e) {
    this.setState({repeatedPassword: e.target.value})
  }

  onChangePasswordClick(e) {
    const { validPassword, newPassword } = this.state
    const { resetPassword } = this.props
    if (!validPassword) return
    resetPassword(getParam('reset_token'), newPassword)
    this.setState(
      {
        validPassword: true,
        passwordNotification: null,
        newPassword: "",
        repeatedPassword: ""
      }
    )
    window.location.href = getBaseUrl()
  }

  renderPasswordNotification() {
    const { t } = this.props
    const { validPassword, passwordNotification } = this.state
    if (!validPassword && passwordNotification) return (
      <InfoText text={ t(passwordNotification)}></InfoText>
    )
  }

  renderPasswordChangeButton() {
    const { validPassword } = this.state
    const { t } = this.props
    if (!validPassword) return (
      <button disabled="disabled" >
        { t('user:profile.passwordChangeButtonLabel') }
      </button>
    )
    return (
      <button
        className="action"
        onClick={ this.onChangePasswordClick.bind(this) }
      >
        { t('user:profile.passwordChangeButtonLabel') }
      </button>
    )
  }

  render() {
    const { t } = this.props
    const { newPassword, repeatedPassword } = this.state

    return <div className="password-reset component">
      { this.renderVideo() }
      <div className="wrapper form">
        <div className="logo-wrapper">
          <img
              className="logo"
              src={ logo }
              alt={ t('user:login.logoAlt') }
              title={ t('user:login.logoTitle') }
          />
        </div>
        <div>
          <input
            className="passwordInput"
            type="password"
            value={ newPassword }
            ref={ (elem) => { this.passwordInput = elem }}
            placeholder={ t('user:profile.passwordInput.placeholder') }
            onChange={ this.onNewPasswordChange.bind(this) }
            onKeyDown={ this.onKeyDown.bind(this)}
          />
          <input
            className="passwordRepeatInput"
            type="password"
            value={ repeatedPassword }
            ref={ (elem) => { this.passwordRepeatInput = elem }}
            placeholder={ t('user:profile.passwordRepeatInput.placeholder') }
            onChange={ this.onRepeatPasswordChange.bind(this) }
            onKeyDown={ this.onKeyDown.bind(this)}
          />
          { this.renderPasswordNotification() }
          { this.renderPasswordChangeButton() }
          { this.renderChromeMessage() }
        </div>
      </div>
    </div>
  }
}

PasswordReset.propTypes = {}

function mapStateToProps(state){
  return {
    error: state.user.error,
    loggedIn: state.user.loggedIn
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resetPassword
    },
    dispatch
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordReset)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/user/password-reset.jsx